import { useState, useEffect } from "react";
import { Coins, Clock, Trophy, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }
function fmtR(v) { return v == null ? "R$ 0" : "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2 }); }

export default function DoletasWidget() {
  var _stats = useState(null);
  var stats = _stats[0];
  var _top = useState([]);
  var top3 = _top[0];
  var navigate = useNavigate();

  useEffect(function () {
    async function load() {
      try {
        var res = await api.get("/doletas/stats");
        _stats[1](res.data);
        if (res.data.program_enabled) {
          var rk = await api.get("/doletas/ranking?limit=3");
          _top[1](rk.data.ranking || []);
        }
      } catch (e) {}
    }
    load();
  }, []);

  if (!stats || !stats.program_enabled) return null;

  return (
    <div className="bg-gradient-to-br from-[#0A2F3D] to-[#163d4f] rounded-xl lg:rounded-2xl p-4 lg:p-5 shadow-sm mb-6 lg:mb-8" data-testid="doletas-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Coins className="w-5 h-5 text-amber-400" />
          <h3 className="text-sm lg:text-base font-bold text-white">Programa DOLETAS</h3>
        </div>
        <button onClick={function () { navigate("/doletas"); }}
          className="flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors"
          data-testid="doletas-widget-link">
          Ver tudo <ArrowRight className="w-3 h-3" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Clock className="w-4 h-4 mx-auto mb-1 text-amber-400" />
          <p className="text-lg font-bold text-white" data-testid="widget-pending">{fmt(stats.total_pending)}</p>
          <p className="text-[10px] text-white/50">Pendentes</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Coins className="w-4 h-4 mx-auto mb-1 text-emerald-400" />
          <p className="text-lg font-bold text-white" data-testid="widget-total">{fmt(stats.total_doletas_circulando)}</p>
          <p className="text-[10px] text-white/50">Circulando</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Trophy className="w-4 h-4 mx-auto mb-1 text-blue-400" />
          <p className="text-lg font-bold text-white" data-testid="widget-participants">{fmt(stats.total_participants)}</p>
          <p className="text-[10px] text-white/50">Participantes</p>
        </div>
      </div>
      {top3.length > 0 && (
        <div className="space-y-1.5">
          {top3.map(function (r) {
            var badges = ["text-amber-400", "text-gray-300", "text-orange-400"];
            return (
              <div key={r.user_id} className="flex items-center justify-between bg-white/5 rounded-lg px-3 py-2">
                <div className="flex items-center gap-2">
                  <span className={"text-sm font-bold " + (badges[r.position - 1] || "text-white/40")}>{r.position}o</span>
                  <span className="text-xs text-white/80 truncate max-w-[120px]">{r.user_name}</span>
                  <span className={"text-[10px] px-1.5 py-0.5 rounded-full " + (r.user_role === "broker" ? "bg-blue-500/20 text-blue-300" : "bg-emerald-500/20 text-emerald-300")}>
                    {r.user_role === "broker" ? "Vend." : "Cliente"}
                  </span>
                </div>
                <span className="text-xs font-semibold text-amber-400">{fmt(r.balance)}</span>
              </div>
            );
          })}
        </div>
      )}
      {stats.total_pending > 0 && (
        <button onClick={function () { navigate("/doletas"); }}
          className="mt-3 w-full py-2 bg-amber-500/20 hover:bg-amber-500/30 border border-amber-400/30 rounded-lg text-xs font-medium text-amber-300 transition-colors"
          data-testid="widget-pending-btn">
          {stats.total_pending} transacoes aguardando aprovacao
        </button>
      )}
    </div>
  );
}
